import React from 'react';
import Youtube from '../Components/Youtube';
import Coach from '../Components/Coach';
import JoinForm from '../Components/JoinForm';
import Announcement from './Announcement';
import img1 from "../img/coach/1.png"
import img2 from "../img/coach/2.png"
import coach1 from '../img/coach/life.png'
import coach2 from '../img/coach/relationship.png'
import coach3 from '../img/coach/grief-supp.png'
import coach4 from '../img/coach/self-dev.png'
import coach5 from '../img/coach/goal settin.png'


const Coaching = () => {
    const coach = [
        {
            img: coach1,
            info: "Life Coaching",
            des: "We counsels and encourages you through personal or career challenges. We help guide our clients to reach their ultimate goals, and  help individuals in different areas of their life. We understand each human being is different so we work closely to fingre out the issue. Book a free consultation now with Rabinandan."
        },
        {
            img: coach2,
            info: "Relationship Coaching",
            des: "Are you going through with a tough moment in  your relationship? Does your partner not care you or do not meet your expections? Does your married life lost love? Do not worry any more. We are here to help you. Book a free consultation with me and get a new spark in your romantic relationship. "
        },
        {
            img: coach3,
            info: "Grief Support",
            des: "We, as  human, do not have control over others' actions. It is likely to get hurted by someone's action. If you are also feeling thretended, depressed and alone then you are not alone and it is not something that happend for the first time. Many people also experienced same. Let me know your sadness and give me this opportunaity to lift you up. Book a free consultation now. "
        },
        {
            img: coach4,
            info: "Self Development",
            des: "We all talk about seft development, some of us even make plans, goals and stick with it for a certain duration. Moreover, with the time or by other factors more than 99% of us stop working on our plans. And, the rest 1% will active the magiz so called 'success'. Let's work on your self development together."
        },
        {
            img: coach5,
            info: "Goal settings",
            des: "Try to remember how many times you have set goals for yourself? I am sure it would be not less that 10 times. No doubt, you have started everytime but it is also true, after a few days or months the inspiration has gone. One of the reason is the the goal you set was not ACTUALLY yours. Lets work together to identify - where you are best at & how can you achive it ?  "
        },
        {
            img: coach5,
            info: "Finance Coaching",
            des: 'We help you improve your relationship with money and stay on track to meet your financial goals."Think of a financial coach like a personal trainer, whose job is to help you discuss, establish and uphold positive routines," says Julie Genjac, managing director of applied insights at Hartford Funds. Just as a personal trainer helps you understand your relationship with food and exercise, then creates strategies to prevent your natural desires from derailing your efforts and encourages you to stick to your plan, a financial coach does the same for your finances.'
        }
    ]
    const certificate = [
        {
            img: img1,
            para: "CERTIFICATE ISSUER: Kain is the CEO of Kairen Holdings Ltd, an online training and community investment company, and Kain Ramsay Ltd. He first developed his reputation as the charismatic co-founder of Achology Ltd.  This unparalleled Life Coaching Certificate Course includes an easy-to-understand curriculum designed to support the development of effective communication skills, wise perspectives, and the ways in which transformational changes can be made to people's beliefs, behaviors, attitudes, careers, and daily interactions. "
        },
        {
            img: img2,
            para: "CERTIFICATE ISSUER: [International Academy of Life Coaching & Entrepreneurship by Joeel and Natalie Rivera ] is top Udemy instructor in the personal development category. Our courses have been taken by over 700,000+ happy students from 200 countries. We have a thriving community in the course and we are actively involved and answer questions within 24h. "
        }
    ]
    const latestNews = [
        {
            title: "Online Meeting for Goal settings",
            date: "28 Jan 2022",
            paragraph: "We will be holding one hour session on goal setting on 28th Jan at 9pm JST. To Join fill the form. Limited seats - hurry. It is free.",
           
        },
        {
            title: "Virtual meet with Kain",
            date: "10 Nov 2022",
            paragraph: "Thank you Kain for your quality lactors on Life coaching. It is certainly helpful for my career.",
        },
        {
            title: "Online session of love relationship",
            date: "09 Oct 2022",
            paragraph: "Announcing online webnier for 'Love in Relationship'.",
        },
        {
            title: "Podcast notification ",
            date: "02 Sept 2022",
            paragraph: "Join our podcast sesstion on 02th Septetmber. Send a enquiry join for free.",
        }
    ]
    return (
        <div className=' xl:px-20 lg:py-10 p-5'>
            <Youtube coach latestNews={latestNews}></Youtube>
            <p>Welcome, I am a certfitied life caoch and relationship counselor. Only one thing is stopping to achieve all your dream is YOU. No one else can divert you from your success if you are commited & dedicated. <br />
            <span>"If you let go a little, you will have a little peace. If you let go a lot, you will have a lot of peace. If you let go completely, you will have the complete peach".</span>
            </p>

            <Coach id='coach' data={coach} free></Coach>
            <JoinForm title="Book Free Consultation" coach/>

            <h2 className=' text-2xl lg:text-3xl mt-10 text-slate-400 font-semibold mb-5 border-b-2 border-cyan-500'>Certification</h2>

            <div className=' grid md:grid-cols-2 grid-cols-1 gap-8 p-3'>
                {
                    certificate.map((c, index) => <div key={index}>
                        <img className='w-3/4 h-[300px] mx-auto mb-5' src={c.img} alt="" />
                        <p>{c.para}</p>
                    </div>)
                }
            </div>

            <Announcement title='News'></Announcement>
        </div>
    );
};

export default Coaching;
